import { Component, inject } from '@angular/core';
import { ContractTypeAssetService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ContractTypeAssetCreateDto,
  ContractTypeAssetDto,
  ContractTypeAssetExcelDownloadDto,
  ContractTypeAssetUpdateDto,
} from '../proxy/controlling/dtos/contract-type-asset';
import { CONTRACTTYPEASSET_CONFIG, CONTRACTTYPEASSET_FIELDS } from './contract-type-asset.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-contract-type-asset',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ContractTypeAssetService, ConfirmationService],
  templateUrl: './contract-type-asset.html',
  styleUrl: './contract-type-asset.scss',
})
export class ContractTypeAsset extends BaseCrudComponent<
  ContractTypeAssetDto,
  ContractTypeAssetCreateDto,
  ContractTypeAssetUpdateDto,
  ContractTypeAssetExcelDownloadDto
> {
  service = inject(ContractTypeAssetService);
  config = CONTRACTTYPEASSET_CONFIG;
  fields = CONTRACTTYPEASSET_FIELDS;

  protected prepareUpdateDto(data: any, selected: ContractTypeAssetDto): ContractTypeAssetUpdateDto {
    return {
      regionId: data.regionId,
      propertyId: data.propertyId,
      isOwnPlantation: data.isOwnPlantation,
      contractTypeId: data.contractTypeId,
      depletionTypeId: data.depletionTypeId,
      assetId: data.assetId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ContractTypeAsset';
  }
}
